var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    viewBox: "0 0 180 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 52H6.66667C3.00167 52 0 49.0734 0 45.5V6.5C0 2.92663 3.00167 2.74817e-06 6.66667 2.74817e-06H173.333C176.998 2.74817e-06 180 2.92663 180 6.5V45.5C180 49.0734 176.998 52 173.333 52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 1.04162C176.42 1.04162 178.932 3.4905 178.932 6.5V45.5C178.932 48.5095 176.42 50.9584 173.333 50.9584H6.66667C3.58 50.9584 1.06833 48.5095 1.06833 45.5V6.5C1.06833 3.4905 3.58 1.04162 6.66667 1.04162H173.333ZM173.333 2.74817e-06H6.66667C3.00167 2.74817e-06 0 2.92663 0 6.5V45.5C0 49.0734 3.00167 52 6.66667 52H173.333C176.998 52 180 49.0734 180 45.5V6.5C180 2.92663 176.998 2.74817e-06 173.333 2.74817e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9152 9.79947C13.5235 10.1992 13.2969 10.8216 13.2969 11.6276V40.3771C13.2969 41.1831 13.5235 41.8055 13.9152 42.2052L14.0119 42.293L30.5352 26.1892V25.809L14.0119 9.70522L13.9152 9.79947Z",
    fill: "url(#paint0_linear_45_2798)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0368 31.5605L30.5352 26.1899V25.8097L36.0435 20.439L36.1668 20.5089L42.6902 24.1278C44.5518 25.1548 44.5518 26.8448 42.6902 27.8783L36.1668 31.4907L36.0368 31.5605Z",
    fill: "url(#paint1_linear_45_2798)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1657 31.4902L30.5341 25.9994L13.9141 42.2055C14.5324 42.8392 15.5407 42.9156 16.6874 42.2819L36.1657 31.4902Z",
    fill: "url(#paint2_linear_45_2798)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1657 20.5091L16.6874 9.71751C15.5407 9.09025 14.5324 9.16663 13.9141 9.80038L30.5341 26L36.1657 20.5091Z",
    fill: "url(#paint3_linear_45_2798)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2234 13.3182C63.2234 14.4037 62.8901 15.273 62.2334 15.9214C61.4784 16.69 60.4951 17.0768 59.2901 17.0768C58.1384 17.0768 57.155 16.6835 56.3484 15.9084C55.54 15.1219 55.1367 14.1567 55.1367 13.0013C55.1367 11.8459 55.54 10.8807 56.3484 10.1007C57.155 9.31903 58.1384 8.92578 59.2901 8.92578C59.8634 8.92578 60.41 9.04116 60.9317 9.25566C61.4517 9.47178 61.875 9.76428 62.1817 10.125L61.4851 10.8108C60.95 10.1949 60.2217 9.89103 59.2901 9.89103C58.4501 9.89103 57.7217 10.177 57.1034 10.7539C56.4917 11.3324 56.185 12.0815 56.185 13.0013C56.185 13.921 56.4917 14.6767 57.1034 15.2552C57.7217 15.8255 58.4501 16.118 59.2901 16.118C60.1817 16.118 60.9317 15.8255 61.5234 15.2487C61.9134 14.8668 62.1351 14.3403 62.1934 13.6675H59.2901V12.7283H63.1634C63.2101 12.9314 63.2234 13.128 63.2234 13.3182Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3676 10.0606H65.7292V12.5306H69.0092V13.4699H65.7292V15.9399H69.3676V16.897H64.6992V9.10352H69.3676V10.0606Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.707 16.897H72.677V10.0606H70.4453V9.10352H75.9403V10.0606H73.707V16.897Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9141 16.897V9.10352H80.9424V16.897H79.9141Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4999 16.897H84.4783V10.0606H82.2383V9.10352H87.7399V10.0606H85.4999V16.897Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1466 15.8954C97.3582 16.6835 96.3816 17.0768 95.2166 17.0768C94.0449 17.0768 93.0682 16.6835 92.2799 15.8954C91.4932 15.1089 91.1016 14.1437 91.1016 13.0013C91.1016 11.8589 91.4932 10.8937 92.2799 10.1072C93.0682 9.31903 94.0449 8.92578 95.2166 8.92578C96.3749 8.92578 97.3516 9.31903 98.1399 10.1137C98.9332 10.9067 99.3249 11.8654 99.3249 13.0013C99.3249 14.1437 98.9332 15.1089 98.1466 15.8954ZM93.0416 15.2422C93.6349 15.8255 94.3566 16.118 95.2166 16.118C96.0699 16.118 96.7982 15.8255 97.3849 15.2422C97.9766 14.6588 98.2766 13.9097 98.2766 13.0013C98.2766 12.0929 97.9766 11.3438 97.3849 10.7604C96.7982 10.177 96.0699 9.88453 95.2166 9.88453C94.3566 9.88453 93.6349 10.177 93.0416 10.7604C92.4499 11.3438 92.1499 12.0929 92.1499 13.0013C92.1499 13.9097 92.4499 14.6588 93.0416 15.2422Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.77 16.897V9.10352H102.02L105.906 15.1648H105.951L105.906 13.6665V9.10352H106.935V16.897H105.861L101.791 10.5368H101.746L101.791 12.0415V16.897H100.77Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8454 28.2783C87.7137 28.2783 85.1554 30.602 85.1554 33.8082C85.1554 36.9883 87.7137 39.3364 90.8454 39.3364C93.9837 39.3364 96.5421 36.9883 96.5421 33.8082C96.5421 30.602 93.9837 28.2783 90.8454 28.2783ZM90.8454 37.1589C89.1271 37.1589 87.6487 35.776 87.6487 33.8082C87.6487 31.8143 89.1271 30.4558 90.8454 30.4558C92.5637 30.4558 94.0487 31.8143 94.0487 33.8082C94.0487 35.776 92.5637 37.1589 90.8454 37.1589ZM78.4304 28.2783C75.2921 28.2783 72.7404 30.602 72.7404 33.8082C72.7404 36.9883 75.2921 39.3364 78.4304 39.3364C81.5671 39.3364 84.1204 36.9883 84.1204 33.8082C84.1204 30.602 81.5671 28.2783 78.4304 28.2783ZM78.4304 37.1589C76.7104 37.1589 75.2271 35.776 75.2271 33.8082C75.2271 31.8143 76.7104 30.4558 78.4304 30.4558C80.1487 30.4558 81.6271 31.8143 81.6271 33.8082C81.6271 35.776 80.1487 37.1589 78.4304 37.1589ZM63.6571 29.9732V32.3229H69.4121C69.2437 33.6359 68.7937 34.6012 68.1037 35.2739C67.2637 36.0864 65.9554 36.9883 63.6571 36.9883C60.1154 36.9883 57.3421 34.2014 57.3421 30.7483C57.3421 27.2952 60.1154 24.5083 63.6571 24.5083C65.5721 24.5083 66.9654 25.2379 67.9937 26.1837L69.6921 24.5278C68.2537 23.1888 66.3404 22.1602 63.6571 22.1602C58.8004 22.1602 54.7188 26.013 54.7188 30.7483C54.7188 35.4835 58.8004 39.3364 63.6571 39.3364C66.2821 39.3364 68.2537 38.4979 69.8037 36.9249C71.3921 35.3763 71.8871 33.1988 71.8871 31.4405C71.8871 30.8945 71.8404 30.3924 71.7571 29.9732H63.6571ZM124.067 31.7948C123.599 30.5582 122.154 28.2783 119.21 28.2783C116.294 28.2783 113.865 30.5192 113.865 33.8082C113.865 36.9054 116.269 39.3364 119.49 39.3364C122.095 39.3364 123.599 37.7878 124.217 36.8859L122.284 35.6298C121.639 36.5495 120.76 37.1589 119.49 37.1589C118.229 37.1589 117.324 36.595 116.744 35.4835L124.329 32.4237L124.067 31.7948ZM116.334 33.6359C116.269 31.5039 118.032 30.4119 119.295 30.4119C120.285 30.4119 121.125 30.8945 121.405 31.5852L116.334 33.6359ZM110.169 39H112.662V22.75H110.169V39ZM106.085 29.51H106.002C105.442 28.8633 104.374 28.2783 103.02 28.2783C100.18 28.2783 97.5837 30.7093 97.5837 33.826C97.5837 36.9249 100.18 39.3364 103.02 39.3364C104.374 39.3364 105.442 38.7465 106.002 38.0803H106.085V38.8733C106.085 40.9874 104.927 42.1233 103.059 42.1233C101.535 42.1233 100.59 41.0508 100.2 40.1489L98.0321 41.0313C98.6571 42.497 100.312 44.3008 103.059 44.3008C105.982 44.3008 108.449 42.6238 108.449 38.5434V28.6147H106.085V29.51ZM103.234 37.1589C101.515 37.1589 100.077 35.7565 100.077 33.826C100.077 31.8777 101.515 30.4558 103.234 30.4558C104.927 30.4558 106.262 31.8777 106.262 33.826C106.262 35.7565 104.927 37.1589 103.234 37.1589ZM135.74 22.75H129.777V39H132.264V32.8429H135.74C138.502 32.8429 141.21 30.8945 141.21 27.7957C141.21 24.6984 138.495 22.75 135.74 22.75ZM135.805 30.5825H132.264V25.0104H135.805C137.662 25.0104 138.722 26.5135 138.722 27.7957C138.722 29.0534 137.662 30.5825 135.805 30.5825ZM151.177 28.2474C149.38 28.2474 147.512 29.0209 146.744 30.7353L148.95 31.6372C149.425 30.7353 150.299 30.4428 151.222 30.4428C152.512 30.4428 153.82 31.1984 153.84 32.5325V32.7032C153.39 32.4497 152.427 32.0743 151.242 32.0743C148.865 32.0743 146.444 33.3499 146.444 35.7305C146.444 37.908 148.39 39.3104 150.579 39.3104C152.252 39.3104 153.175 38.5743 153.755 37.7179H153.84V38.974H156.242V32.7405C156.242 29.8594 154.035 28.2474 151.177 28.2474ZM150.877 37.1524C150.064 37.1524 148.93 36.7592 148.93 35.776C148.93 34.5183 150.344 34.0357 151.567 34.0357C152.662 34.0357 153.175 34.2713 153.84 34.5817C153.645 36.0864 152.317 37.1524 150.877 37.1524ZM164.992 28.6033L162.134 35.6477H162.049L159.094 28.6033H156.412L160.852 38.4475L158.319 43.9254H160.917L167.759 28.6033H164.992ZM142.577 39H145.07V22.75H142.577V39Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2798",
    x1: 29.0681,
    y1: 40.6765,
    x2: 7.258,
    y2: 18.3071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_2798",
    x1: 45.1144,
    y1: 25.998,
    x2: 12.8518,
    y2: 25.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_2798",
    x1: 33.1034,
    y1: 23.0144,
    x2: 3.52709,
    y2: -7.32024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_2798",
    x1: 9.73046,
    y1: 51.7709,
    x2: 22.9376,
    y2: 38.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.7010f510f5a6a5dabac16162f3ad8f68.svg";
export { ForwardRef as ReactComponent };